import { Button, Modal, Toast } from 'dingtalk-design-mobile'
import './ApplicationIssues.less'
import { useSearchParams } from 'react-router-dom'
import useHistory from '@/hooks/useHistory'
import copy from 'copy-to-clipboard'

const ApplicationIssues = () => {
  const [ params ] = useSearchParams()
  const prevPage = params.getAll('page')[0]

  const history = useHistory()

  const handleClick = () => {
    if (prevPage === 'RightsService') {
      history.push('/RightsServiceForm', 'route')
    }else {
      Modal.alert('', '请用手机浏览器打开链接下载资料', [
        {text: '取消', onClick: () => {}},
        {text: '复制链接', onClick: () => {
          Toast.success({
            content: '复制成功',
            duration: 2
          })
          if (prevPage === 'Bailout') {
            copy('https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/%E4%B8%AD%E5%B1%B1%E5%B8%82%E6%80%BB%E5%B7%A5%E4%BC%9A%E5%B8%AE%E6%89%B6%E6%95%91%E5%8A%A9%EF%BC%88%E5%85%B3%E7%88%B1%E4%BA%92%E5%8A%A9%E6%85%B0%E9%97%AE%EF%BC%89%E8%B5%84%E9%87%91%E7%94%B3%E8%AF%B7%E8%A1%A8.docx')
          }else {
            copy('https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/%E4%B8%AD%E5%B1%B1%E5%B8%82%E6%80%BB%E5%B7%A5%E4%BC%9A%E5%B8%AE%E6%89%B6%E6%95%91%E5%8A%A9%EF%BC%88%E5%85%B3%E7%88%B1%E4%BA%92%E5%8A%A9%E6%85%B0%E9%97%AE%EF%BC%89%E8%B5%84%E9%87%91%E7%94%B3%E8%AF%B7%E8%A1%A81.docx')
          }
        }}
      ])
    }
  }
  
  return (
    <div className='pg-application-issues'>
      {
        prevPage === 'RightsService' &&
        <div>
          <p>1、有事实证明自身的合法劳动权益受到侵害;</p>
          <p>2、用人单位所在地在中山，或者劳动争议仲裁、诉讼案件管辖地在中山;</p>
          <p>3、劳动争议未超过仲裁、诉讼时效;</p>
          <p>4、涉案标的在3000元以上，且本人平均月收入低于中山市最低生活保障标准3倍(含)以内的。以上所称“本人平均月收入”是指申请人近12个月薪资收入的月平均值。</p>
          <p>5、职工因请求支付劳动报酬或者工伤赔偿申请法律援助的，可不受第 (四)项规定的经济困难标准的限制。</p>
        </div>
      }
      {
        prevPage === 'Hospital' && 
        <div>
          <p>1、在职职工会员本人因患病、工伤、意外伤害等在市内外医疗保险定点医疗机构连续住院5天以上，可申领500元住院暖心慰问。</p>
          <p className='blod'>具体发放条件依据《中山市总工会在职工会会员关爱互助慰问金实施办法 (2022年修订)》规定执行。文件可在中山市总工会网站查询</p>
        </div>
      }
      {
        prevPage === 'Medical' && 
        <div>
          <p>1、在职职工会员患重大疾病或其他花费巨大的疾病，在市内外医疗保验定点医疗机构接受治疗，近12个月门诊、住院个人自付、自费金额累计到一定金额(重大疾病自付、自费金额1万元以上，其他疾伤3万元以上)，根据个人自付、自费总金额发放相应的慰问金。</p>
          <p>职工本人因病身故，死亡之日起12个月内，可由其配偶或其他直系亲属申请身故慰问金。</p>
          <p className='blod'>具体发放条件依据《中山市总工会在职工会会员关爱互助慰问金实施办法 (2022年修订)》规定执行。文件可在中山市总工会网站查询。</p>
        </div>
      }
      {
        prevPage === 'Injury' && 
        <div>
          <p>1、在职职工会员本人受工伤事故伤害住院治疗的，可在认定工伤之日起12个月内申领慰问金。</p>
          <p className='blod'>具体发放条件依据《中山市总工会在职工会会员关爱互助慰问金实施办法(2022年修订)》规定执行。文件可在中山市总工会网站查询</p>
        </div>
      }
      {
        prevPage === 'Accidental' && 
        <div>
          <p>1、在职职工会员因意外伤害在市内外医疗保险定点医行机构治疗的，近12个月门诊。住院个人自付、自费金额累计2万元以上的，根据个人自付、自费总金额发放相应的慰问金。</p>
          <p className='blod'>具体发放条件依据《中山市总工会在职工会会员关爱互助慰问金实施办法(2022年修订)》规定执行。文件可在中山市总工会网站查询</p>
        </div>
      }
      {
        prevPage === 'Bailout' && 
        <div>
          <p>认定为困难职工的在职职工会员本人或其家庭主要成员，患重大疾病、其他花费巨大的疾病或遭遇重大意外伤害，在市内外医疗保险定点医疗机构接受治疗，近12个月门诊、住院个人自付、自费金额累计到一定金额 (重大疾病1万元以上，其他疾病3万元以上，遭遇意外伤害2万元以上)，根据个人自付、自费总金额发放不同的慰问金。困难职工会员本人因病身故死亡之日起12个月内，可由其配偶或其他直系亲属申请身故慰问金。</p>
          <p className='blod'>具体发放条件依据《中山市总工会困难职工帮扶救助实施办法(2022年修订)》规定执行。文件可在中山市总工会网站查询。</p>
        </div>
      }
      <Button className='btn' onClick={handleClick}>我要申请</Button>
    </div>
  )
}

export default ApplicationIssues